import { useMutation } from "@tanstack/react-query";
import { performTrackedSignOut } from "./client";

export function useTrackedSignOut(
  options: Parameters<typeof performTrackedSignOut>[0],
) {
  return useMutation({
    mutationFn: () => performTrackedSignOut(options),
  });
}
